export const TimerComp = ({ time, justTimer = false }: any) => {
  return (
    <span className="timer_comp">
      {!justTimer && <p>Ends in </p>}
      <span> {time || "--:--:--"} </span>
    </span>
  );
};
